import { useSelector } from "react-redux";
import { RootState } from '../../redux/redux-store';
import { useGetMediaPlanQuery } from "src/redux/survey/media-plan.endpoints";
import { SurveyMediaPlan } from "src/redux/survey/media-plan.types";
import { useGetSurveyQuery, useGetSurveyStatsQuery, useGetSurveySummaryQuery } from "src/redux/survey/survey.endpoints";
import { SurveyFull, SurveyStats, SurveySummaryData } from "src/redux/survey/survey.types";

export interface ViewSurveyChildrenProps {
  surveyId: string;
  isShare: boolean;
  isLoadingSummary?: boolean;
  isGeneratingSummary?: boolean;
  isLoadingMediaPlan?: boolean;
  isGeneratingMediaPlan?: boolean;
  createSummary?: () => void;
  createMediaPlan?: () => void;
}

interface UseViewSurveyChildrenReturn {
  readonly isSurveyError: boolean;
  readonly survey?: SurveyFull;
  readonly stats?: SurveyStats;
  readonly summary?: SurveySummaryData;
  readonly mediaPlan?: SurveyMediaPlan;
}

export const useViewSurveyChildren = (surveyId: string, isShare: boolean = false): UseViewSurveyChildrenReturn => {
  const selectedAnswerIds = useSelector((state: RootState) => {
    return state.selectedAnswers.selectedAnswerIds;
  });

  const params = { ext_survey_id: surveyId, share: isShare, selected_survey_answers: selectedAnswerIds };
  const { data: survey, isError: isSurveyError } = useGetSurveyQuery(params);
  const { data: stats } = useGetSurveyStatsQuery(params);
  const { data: summary } = useGetSurveySummaryQuery(params);
  const { data: mediaPlan } = useGetMediaPlanQuery(params);

  return {
    isSurveyError,
    survey,
    stats,
    summary,
    mediaPlan,
  };
};
